import { ReactElement } from "react";
import { Center } from "@chakra-ui/react";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";
import { CATEGORY_COLORS, NotificationCategory } from "./notificationTypes";

// チップの中では、行より一回り小さくする
const SIZES = {
  row: { boxSize: "20px", fontSize: "11px" },
  chip: { boxSize: "16px", fontSize: "10px" },
} as const;

/*
 * 種別を示す1文字の丸（低・高・傾・未）。行の左端とチップの頭に置き、チップでは凡例を兼ねる
 */
export function CategoryMark(
  props: Readonly<{
    category: NotificationCategory;
    size: keyof typeof SIZES;
    /** オフのチップの丸。種別の色をやめて灰色にする */
    isOff?: boolean;
  }>,
): ReactElement {
  const { category, size, isOff = false } = props;
  const t = useModifiedTranslation();
  const colors = CATEGORY_COLORS[category];

  return (
    <Center
      flexShrink={0}
      rounded="full"
      {...SIZES[size]}
      bg={isOff ? "gray.100" : colors.bg}
      color={isOff ? "gray.400" : colors.text}
      fontWeight="bold"
      lineHeight={1}
      data-testid="notification-mark"
    >
      {t(`Notification.mark.${category}`)}
    </Center>
  );
}
